<template>
  <div id="app" v-loading="isLoading">
    <!-- something wrong happened when trying to show the survey -->
    <div v-show="error" class="unavailable">{{ $t('surveyIsUnavailable') }}</div>

    <!-- survey -->
    <i-dalgo-survey v-show="!error" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import iDalgoSurvey from '@/components/iDalgo-Survey'
import i18n from '@/lang/index'

export default {
  name: 'app',
  components: {
    iDalgoSurvey
  },
  computed: {
    ...mapGetters({
      isLoading: 'survey/isLoading',
      error: 'survey/error'
    })
  },
  async mounted () {
    this.$store.commit('survey/SURVEY_KEY_UPDATED', window.location.href.split('/', 4).slice(-1).pop())
    await this.$store.dispatch('survey/loadSurvey')
    let surveyId = this.$store.getters['survey/surveyId']
    i18n.locale = this.$store.state.survey.survey.locale

    // if the first question has been voted, display the results (works for surveys with 1 question only)
    try {
      const userVotes = localStorage[`iDalgoSurvey-${surveyId}`]
      if (userVotes && JSON.parse(userVotes)[0] && JSON.parse(userVotes)[0].answers) {
        this.$store.commit('survey/USER_VOTES_UPDATED', JSON.parse(userVotes) || undefined)
      }
    } catch (e) {}
  },
  watch: {
    title () {
      if (!this.title) {
        document.title = this.$t('head.title')
      } else {
        document.title = this.$t('head.title') + ' - ' + this.title
      }
    }
  }
}
</script>

<style lang="scss">
body, html {
  background-color: $background-color;
  padding: 0;
  margin: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s, transform 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(25%);
}

.fading-enter-active, .fading-leave-active {
  transition: opacity 0.2s;
}
.fading-enter, .fading-leave-to {
  opacity: 0;
}
</style>

<style lang="scss" scoped>
#app {
  position: relative;
}

* {
  font-family: 'nunitoregular';
  letter-spacing: 0.5px;
}

.unavailable {
  font-size: 20px;
  text-align: center;
  padding: 20px;
}
</style>
